import React, { useReducer, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import { CircularProgress } from '@material-ui/core';
import { decisionReducer } from "../../../Utils/requestUtils"
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from '@material-ui/icons/Clear';
import { useTranslation } from "react-i18next";

const getConfirmationIcon = (success) => {
    if (success) {
        return (<CheckIcon className="fraudStatusIcon" style={{ color: '#73C580', width: "40px", height: "40px" }} />)
    }
    else {
        return (<ClearIcon className="fraudStatusIcon" style={{ color: '#D91A1A', width: "40px", height: "40px" }} />)
    }
}

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

function ChangesPreviewDialog(props) {
    const { t } = useTranslation();
    let { changesPreview, loading } = props

    const history = useHistory()

    const [dialogState, dispatchDialogState] = useReducer(
        decisionReducer,
        { isLoading: false, isError: false, finished: false }
    )

    const handleCloseDialog = () => {
        props.onClose()
        setTimeout(function () { dispatchDialogState({ type: "default_state" }) }, 500)
    }

    if (dialogState.finished && dialogState.isLoading) {
        return (
            <Dialog
                open={props.open}
                onClose={() => history.push("/rule-pieces-inbox")}
                keepMounted={false}
                disableBackdropClick
                disableEscapeKeyDown
            >
                <DialogTitle style={{ paddingBottom: "0px" }} className={["blueText", "normalMediumSize"].join(" ")}>{t("Salvando Regra")}</DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", width: "310px", height: "217px" }}>
                        <CircularProgress style={{ margin: "auto" }} />
                    </div>
                </DialogContent>
            </Dialog>

        )
    }
    else if (dialogState.finished) {
        let confirmationData = {
            message: dialogState.message,
            success: !dialogState.isError
        }
        return (
            <Dialog
                open={props.open}
                onClose={confirmationData.success ? () => history.push("/rule-pieces-inbox") : handleCloseDialog}
                keepMounted={false}
                disableBackdropClick
            >
                <DialogTitle style={{ paddingBottom: "0px" }} className={["blueText", "normalMediumSize"].join(" ")}>{t("Confirmação de Revisão")}</DialogTitle>
                <DialogContent>
                    <div style={{ width: "310px", height: "217px" }}>
                        <div className="internalCardContainer" style={{ display: "flex", height: "40%", justifyContent: "center" }}>
                            {getConfirmationIcon(confirmationData.success)}
                        </div>
                        <div className="internalCardContainer" style={{ display: "flex", textAlign: "center", justifyContent: "center" }}>
                            {confirmationData.message}
                        </div>
                        <div className="internalCardContainer" style={{ display: "flex", justifyContent: "center" }}>
                            <div
                                className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                                onClick={confirmationData.success ? () => history.push("/rule-pieces-inbox") : handleCloseDialog}
                            >
                                {confirmationData.success ? t("VOLTAR À TELA INICIAL") : "FECHAR"}
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        )

    }
    return (
        <Dialog
            open={props.open}
            onClose={handleCloseDialog}
            keepMounted={false}
        >
            <DialogTitle style={{ paddingBottom: "0px" }} className={["blueText", "normalMediumSize"].join(" ")}>{t("Prévia das mudanças")}</DialogTitle>
            <DialogContent>

                {
                    loading
                        ?
                        <div
                            style={{
                                width: "366px", height: "80px",
                                display: "flex", flexDirection: "column",
                                marginBottom: "30px", alignItems: "center"
                            }}
                        >
                            <CircularProgress style={{ margin: "auto" }} />
                        </div>
                        :
                        changesPreview
                            ?
                            <div
                                style={{
                                    width: "450px", height: "auto",
                                    display: "flex", flexDirection: "column",
                                    marginBottom: "20", alignItems: "center"
                                }}
                            >
                                <div
                                    className={["internalCardContainer", "normalText", "normalMediumSize", "blueText"].join(" ")}
                                    style={{ width: "90%", textAlign: "center" }}>
                                    <strong>{t("Antes")}</strong>
                                </div>
                                <div
                                    className={["internalCardContainer", "normalText", "normalMediumSize"].join(" ")}
                                    style={{ width: "90%", textAlign: "center", marginTop: '0' }}   
                                >
                                    <PreviewCard title={"Variáveis de Processadores"} dataList={changesPreview.current?.processors_variables} t={t}/>
                                    <PreviewCard title={"Campos de Evento"} dataList={changesPreview.current?.field_mapping} t={t}/>
                                </div>
                                <div
                                    className={["internalCardContainer", "normalText", "normalMediumSize", "blueText"].join(" ")}
                                    style={{ width: "90%", textAlign: "center", marginTop: '0' }}>
                                    <strong>{t("Depois")}</strong>
                                </div>
                                <div
                                    className={["internalCardContainer", "normalText", "normalMediumSize"].join(" ")}
                                    style={{ width: "90%", textAlign: "center" }}
                                >
                                    <PreviewCard title={"Variáveis de Processadores"} dataList={changesPreview.preview?.processors_variables} t={t}/>
                                    <PreviewCard title={"Campos de Evento"} dataList={changesPreview.preview?.field_mapping} t={t}/>
                                </div>
                                <div className="internalCardContainer" style={{ display: "flex", marginTop: "10px" }}>
                                    <div
                                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                        style={{ width: "120px" }}
                                        onClick={handleCloseDialog}
                                    >
                                        {t("Fechar")}
                                    </div>
                                </div>
                            </div>
                            : <div
                                style={{
                                    width: "366px", height: "120px",
                                    display: "flex", flexDirection: "column",
                                    marginBottom: "30px", alignItems: "center"
                                }}
                            >
                                <div
                                    className={["internalCardContainer", "normalText", "normalMediumSize"].join(" ")}
                                    style={{ width: "90%", textAlign: "center" }}>
                                    <strong>{t("Erro ao buscar prévia das mudanças")}</strong>
                                </div>
                                <div className="internalCardContainer" style={{ display: "flex", marginTop: "10px" }}>
                                    <div
                                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                        style={{ width: "120px" }}
                                        onClick={handleCloseDialog}
                                    >
                                        {t("Fechar")}
                                    </div>
                                </div>
                            </div>
                }
            </DialogContent>
        </Dialog>
    )
}

const PreviewCard = ({ title, dataList = [], t }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="internalCardContainer normalText normalMediumSize" style={{ marginBottom: '1rem' }}>
            <Typography variant="subtitle1" onClick={() => setOpen(!open)} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }}>
                <strong>{t(title)}</strong>: {dataList.length}
                <IconButton size="small" onClick={() => setOpen(!open)}>
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Typography>

            <Collapse in={open}>
                <div style={{ maxHeight: '200px', overflowY: 'auto', padding: '10px', textAlign: 'start', backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
                    {dataList.length > 0 ? (
                        dataList.map((item, index) => (
                            <Typography key={index} variant="body2" style={{marginTop: '10px'}}>
                                • {t(item.description)}
                            </Typography>
                        ))
                    ) : (
                        <Typography variant="body2" color="textSecondary">{t("Nenhum item")}</Typography>
                    )}
                </div>
            </Collapse>
        </div>
    );
};

export default ChangesPreviewDialog;